export default "__VITE_ASSET__DOd8LBtj__"